import { WidgetAction, WidgetData } from '../actions/widget';

const initialState: WidgetData | null = null;

const widgetReducer = (state: WidgetData | null = initialState, action: WidgetAction): WidgetData | null => {
	switch (action.type) {
		case 'widget/add-data':
			return action.payload;
		default:
			return state;
	}
};

export default widgetReducer;
